// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
	JSON PRETTY PRINT 
*/
pre {padding: 5px; margin: 0; }
.string { color: green; }
.number { color: darkorange; }
.boolean { color: blue; }
.null { color: magenta; }
.key { color: red; }`, "",{"version":3,"sources":["webpack://./src/assets/css/jsplumbtoolkit-syntax-highlighter.css"],"names":[],"mappings":"AAAA;;CAEC;AACD,KAAK,YAAY,EAAE,SAAS,EAAE;AAC9B,UAAU,YAAY,EAAE;AACxB,UAAU,iBAAiB,EAAE;AAC7B,WAAW,WAAW,EAAE;AACxB,QAAQ,cAAc,EAAE;AACxB,OAAO,UAAU,EAAE","sourcesContent":["/* \r\n\tJSON PRETTY PRINT \r\n*/\r\npre {padding: 5px; margin: 0; }\r\n.string { color: green; }\r\n.number { color: darkorange; }\r\n.boolean { color: blue; }\r\n.null { color: magenta; }\r\n.key { color: red; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
